import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { H2 } from '#app/components/typography/h2.tsx'
import { CodeBlock } from '#app/old/components/data-display/code-block.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Visually Hidden',
}

const component: componentProps = {
	name: 'Visually Hidden',
	shortName: 'VisuallyHidden',
	fileName: 'visually-hidden',
	category: 'layout',
	description: [
		'Hides its children visually, while keeping content visible to screen readers. This would typically be used to visually hide labels but keeping them accessible to screen readers, and when you want to take advantage of the behavior and semantics of a native element (like a checkbox or radio button), but replace it with a custom styled element.',
	],
	features: ['Visually hides content while preserving it for assistive technology.'],
	parts: [
		{
			name: 'VisuallyHidden',
			description: 'Hides its children visually, while keeping content visible to screen readers.',
		},
	],
	usage: `<Button>
	<Icon name="bars-3" />
	<VisuallyHidden>Open sidebar</VisuallyHidden>
</Button>`,
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const VisuallyHiddenRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts } = component

	return (
		<>
			<Description name={name} description={description} />
			<Features features={features} />
			<Parts parts={parts} />
			<H2>Usage</H2>
			<CodeBlock code={usage} filename={`${shortName}Example`} extension="tsx" className="mt-4" />
			<Source source={source} fileName={fileName} />
		</>
	)
}
export default VisuallyHiddenRoute
